import { ProductType } from '../../../models/ProductType';
import { LocationChangeAction } from 'connected-react-router';

export type ProductTypeAction = ProductTypeCahnge;

export type ProductTypeCahnge = {
    type: 'PRODUCT_TYPE_CHANGE';
    payload: ProductType | null;
};

export default function productTypeReducer(
    state: ProductType | null = null,
    action: ProductTypeCahnge | LocationChangeAction
): ProductType | null {
    switch (action.type) {
        case 'PRODUCT_TYPE_CHANGE':
            return action.payload;
        default:
            return state;
    }
}
